export enum DIRECTION {
  UP = -0b01,
  DOWN = 0b01,
}
